import request from '@utils/request'
import cloneDeep from 'lodash/cloneDeep'

export const state = {
  modifyMemberInfo: {}, // 原始訂單會員資料
  modifyOrder: {}, // 原始訂單資料
  isTempOrder: false
}

export const getters = {
  isModified(state) {
    return Object.keys(state.modifyMemberInfo).length > 0 && Object.keys(state.modifyOrder).length > 0
  },
  modifyPetInfo(state, getters) {
    return getters.isModified ? [state.modifyOrder.pet] : []
  },
  modifyData(state, getters) {
    if (!getters.isModified) return {}

    const { modifyOrder } = state
    return {
      params: modifyOrder.params,
      fullName: modifyOrder.fullName,
      gender: modifyOrder.gender,
      phoneCode: '+886',
      phoneNumber: modifyOrder.phoneNumber,
      phone: '',
      // bankType:'',
      email: modifyOrder.email,
      note: modifyOrder.note,
      status: modifyOrder.status,
      paymentStatus: 'UNPAID',
      basePrice: '',
      total: '',
      allowExpired: modifyOrder.allowExpired,
      couponCode: '',
      memberId: modifyOrder.memberId,
      prepaidOrderUuid: modifyOrder.prepaidOrderUuid,
      customerInfos: modifyOrder.customerInfos,
      // paymentMethod: 'Prepaid',
      paymentMethod: '',
      productId: modifyOrder.productId,
      bankType: '',
      address: modifyOrder.address,
      petId: modifyOrder.pet.id,
      city: modifyOrder.city,
      district: modifyOrder.district,
      errorHandle: false,
      type: '',
      scheduleItemId: modifyOrder.scheduleItem.id,

      // 假資料先暫做
      storeCredit: '',
      credit: '',
    }
  },
}

export const mutations = {
  GET_ORDER_INFO(state, order) {
    state.modifyOrder = order
  },
  GET_MEMBER_INFO(state, member) {
    state.modifyMemberInfo = member
  },
  CLEAR_DATA(state) {
    state.modifyMemberInfo = {}
    state.modifyOrder = {}
  },
  TEMP_ORDER_CHECK(state, status) {
    state.isTempOrder = !status
  },
}
